import { mapActions, mapState } from 'vuex';
import moment from 'moment';

export default {
	computed: {
		...mapState({
		})
	},
	methods: {
		helpers() {
      const createFakeCallCenterPhoneNumber = () => {
        // Create the <a> element
        const telLink = document.createElement('a');
        telLink.href = 'tel:1111111111';
        telLink.target = '_blank';
        telLink.rel = 'noopener';

        // Add styled text content
        const span = document.createElement('span');
        span.style.textDecoration = 'underline';

        const strong = document.createElement('strong');
        strong.textContent = '111-111-1111';

        // Nest elements
        span.appendChild(strong);
        telLink.appendChild(span);

        // Append to the app root
        document.body.insertBefore(telLink, document.body.firstChild);
      };
      
			const callCenterPhoneNumber = () => {
        const telLink = document.querySelector('a[href^="tel:"][target="_blank"][rel="noopener"]');

        if (telLink) {
          const telText = telLink.textContent.trim();
          return telText || '855-442-4516'; // fallback if text is empty
        }

        // Default if no link is found
        return '855-442-4516';
			};
			const formatterLongDate = (arg) => {
				let val = arg ? moment(arg).format('ddd. MMMM Do YYYY') : '';
				return val;
			};
			const formatterDayShorthand = (arg) => {
				let val = arg ? moment(arg, 'MM/DD/YYYY').format('D') : '';
				return val;
			};
			const formatterTime = (arg) => {
				let val = arg ? moment(arg).format('h:mm A') : '';
				return val;
			};
			return {
				callCenterPhoneNumber,
				formatterLongDate,
				formatterDayShorthand,
				formatterTime
			};
		},
		OnlineSchedulingHelpers() {
			return {
				buildCalendar(arg) {
					let _date = arg.date;
					let _start = moment(_date, 'MM/DD/YYYY').startOf('week').format('MM/DD/YYYY');
					return {
						year: moment(_date !== _start ? _date : _start, 'MM/DD/YYYY').format('YYYY'),
						month: moment(_date !== _start ? _date : _start, 'MM/DD/YYYY').format('MMMM'),
						week: [
							{
								title: 'SUN',
								date: _start,
								timeslots: [],
							},
							{
								title: 'MON',
								date: moment(_start, 'MM/DD/YYYY').add(1, 'days').format('MM/DD/YYYY'),
								timeslots: [],
							},
							{
								title: 'TUES',
								date: moment(_start, 'MM/DD/YYYY').add(2, 'days').format('MM/DD/YYYY'),
								timeslots: [],
							},
							{
								title: 'WED',
								date: moment(_start, 'MM/DD/YYYY').add(3, 'days').format('MM/DD/YYYY'),
								timeslots: [],
							},
							{
								title: 'THU',
								date: moment(_start, 'MM/DD/YYYY').add(4, 'days').format('MM/DD/YYYY'),
								timeslots: [],
							},
							{
								title: 'FRI',
								date: moment(_start, 'MM/DD/YYYY').add(5, 'days').format('MM/DD/YYYY'),
								timeslots: [],
							},
							{
								title: 'SAT',
								date: moment(_start, 'MM/DD/YYYY').add(6, 'days').format('MM/DD/YYYY'),
								timeslots: [],
							}
						]
					};
				}
			};
		}
	}
};
